import { Database } from '@databases/types/database';
import { getEntryIdFromValueId, getFieldIdFromValueId } from '@databases/utils/utils';

export const threadsForField = (database: Database, fieldId: string) => {
  return Object.keys(database.commentThreads)
    .filter((valueId) => getFieldIdFromValueId(valueId) === fieldId)
    .map((valueId) => database.commentThreads[valueId]);
};

export const fieldHasThreads = (database: Database, fieldId: string) => {
  return threadsForField(database, fieldId).length > 0;
};

/**
 * Given an threadId and comments object, it will
 * return the associated thread object as well as
 * it's entryId and fieldId.
 */
export const getThreadObjectFromId = (
  threadId: string | undefined,
  comments: Record<
    string,
    {
      threadId: string;
      isResolved: boolean;
      commentCount: number;
      versionNumber: number;
    }[]
  >
) => {
  if (threadId) {
    for (const [valueId, threads] of Object.entries(comments)) {
      const thread = threads.find((thread) => thread.threadId === threadId);
      if (thread) {
        return {
          thread,
          entryId: getEntryIdFromValueId(valueId),
          fieldId: getFieldIdFromValueId(valueId),
        };
      }
    }
  }
};
